import React from "react";
import "./Courses.css";
import { Link } from "react-router-dom";
import * as Constant from '../Constant';

class Course extends React.Component {
    constructor() {
        super();
        this.state = {
            courseList: [],
            isLoading: false
        }
    }

    componentDidMount = () => {
        this.getCourses();
    }

    getCourses = async () => {
        this.setState({ isLoading: true });
        await fetch(Constant.getCourses, {
            method: 'GET'
        })
        .then(Response => Response.json())
        .then(data => {
            this.setState({ courseList: data.data, isLoading: false });
        });
    }

    render() {
      const { courseList, isLoading } = this.state;

      return (
          <div className="courses-container">
              {/* Hero Section */}
             {/* Hero Section */}
              {/* Hero Section */}
              <section className="courses-hero">
                <div className="hero-overlay"></div>
                <div className="hero-content">
                  <h1 className="hero-title">Expand Your Knowledge</h1>
                  <p className="hero-subtitle">Discover our expertly crafted courses designed to elevate your skills</p>
                </div>
              </section>

              {/* Courses Section */}
              <section className="courses-section">
                  <div className="container">
                      {isLoading ? (
                          <div className="loading-spinner">
                              <div className="spinner"></div>
                              <p>Loading courses...</p>
                          </div>
                      ) : (
                          <div className="courses-grid">
                              {courseList.map((item) => (
                                  <article className="cardquiz" key={item.id}>
                                      <img
                                          className="card__background"
                                          src={item.image}
                                          alt={item.course_name}
                                          loading="lazy"
                                      />
                                      <div className="card-overlay"></div>
                                      <div className="card__content flow">
                                          <div className="card__content--container flow">
                                              <h2 className="card__title">{item.course_name}</h2>
                                              <p className="card__description">
                                                  {item.course_title}
                                              </p>
                                          </div>
                                          <Link to={`/course_details/${item.slug}`} className="lending-btn">
                                              Show Details
                                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
                                                  <path fill="none" d="M0 0h24v24H0z"/>
                                                  <path d="M16.172 11l-5.364-5.364 1.414-1.414L20 12l-7.778 7.778-1.414-1.414L16.172 13H4v-2z" fill="currentColor"/>
                                              </svg>
                                          </Link>
                                      </div>
                                  </article>
                              ))}
                          </div>
                      )}
                  </div>
              </section>
          </div>
      );
  }
}

export default Course;